import React from 'react'

export default class CategoryCard extends React.Component {
  constructor() {
    super()
    this.onCheckboxChange = this.onCheckboxChange.bind(this)
  }

  onCheckboxChange(e) {
    return this.props.onCategoryCheckboxChange(
      e.currentTarget.value,
      e.currentTarget.checked
    )
  }

  render() {
    const categoryId = `category-${this.props.data.id}`
    const checked = this.props.selectedCategories.indexOf(this.props.data.attributes.title) >= 0

    return (
      <div className="section__item">
        <input
          id={categoryId}
          className="checkbox is-spaced"
          type="checkbox"
          checked={checked}
          value={this.props.data.attributes.title}
          onChange={this.onCheckboxChange}
          ref={(input) => { this.categoryCheckbox = input }}
        />

        <label htmlFor={categoryId}>{this.props.data.attributes.title}</label>
      </div>
    )
  }
}
